import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleTeaser() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            Knowledge Base
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Explore SEO Articles &amp; Guides
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Dive deeper into our comprehensive resources covering every aspect of VigorBuy Spreadsheet and business productivity.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((art) => (
            <Link
              key={art.seq}
              to={`/${art.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all overflow-hidden"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={art.image}
                  alt={art.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-[10px] font-semibold">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className={`${art.icon} text-xs`}></i>
                    </span>
                    {art.readTime}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {art.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                  {art.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 whitespace-nowrap">
                  Read Article
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 p-6 md:p-8 rounded-2xl bg-accent-50 border border-accent-200 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="flex-1">
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
              Visit the Official VigorBuy Spreadsheet Store
            </h3>
            <p className="text-sm text-foreground-600">
              Explore our full catalog across Shoes, Hoodies, T-Shirts, Jackets, Accessories, and more.
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-accent-500 text-white hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            Shop Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}